var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-role":_vm.type}},[_c('div',{staticClass:"product-list"},[_c('div',{ref:"container",staticClass:"row"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"col-md-3"},[_c('slider-item',_vm._b({},'slider-item',item,false))],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }